import type { ComponentType } from "react";
import type { SlideProps } from "@/engine/app/offsite-config";
import { Slide03Zugang } from "./slides/Slide03Zugang";
import { SlideThema } from "./slides/SlideThema";
import { SlideArbeitsphase } from "./slides/SlideArbeitsphase";
import { SlideGenerierung } from "./slides/SlideGenerierung";
import {
  SlideS1Strategie,
  SlideS2Werkzeuge,
  SlideE1,
  SlideE2,
  SlidePrompten,
  SlideV1,
  SlideV2,
  SlideV3,
  SlideT1,
  SlideT2,
  SlideT3,
  SlideA1,
} from "./slides/rahmen";

/**
 * Sechzehn Folien für 25 Minuten, in der Reihenfolge des Stations-Ablaufs:
 *
 *   0 S1 · 1 S2     — Einstieg: Strategie 2030 + Werkzeuge
 *   2 E1 · 3 E2     — Einführung in die Demo
 *   4 Drei Felder   — was gleich zu tun ist, VOR der Anmeldung
 *   5 Zugang        — Adresse, QR groß: erst der ganze Rahmen, dann die
 *                     Anmeldung (Wunsch 17.09.)
 *   6 Themenwahl
 *   7 Arbeitsphase  — die Zeit groß in der Mitte
 *   8 Bau           — Generierung: Kästchen-Fortschritt, die KI legt los
 *   9–11 V1–V3      — Vortrag Teil 1: was hat das mit uns und der KI zu tun
 *  12–14 T1–T3      — Vortrag Teil 2: Transparenz, Leitplanken, Aufbruch
 *  15 A1            — Abschluss mit Zählern
 *
 * Ergebnisse laufen als Workshop-Overlay. Indizes in offsite.config.ts sind
 * verbindlich.
 */
export const SLIDE_COMPONENTS: ComponentType<SlideProps>[] = [
  SlideS1Strategie,
  SlideS2Werkzeuge,
  SlideE1,
  SlideE2,
  SlidePrompten,
  Slide03Zugang,
  SlideThema,
  SlideArbeitsphase,
  SlideGenerierung,
  SlideV1,
  SlideV2,
  SlideV3,
  SlideT1,
  SlideT2,
  SlideT3,
  SlideA1,
];

export type { SlideProps } from "@/engine/app/offsite-config";
